//import Vue from 'vue';
import { nextTick, toRaw, isProxy } from 'vue';

import {careHSMs} from '@/Shared/appSettings';
import utils from '@/Shared/utils.jsx';
import timezoneMap from '@/Shared/timezoneMap';
import token from '@/Services/token';
import locale, { careWindowsToMomentTimezoneMap } from '@/Services/locale';
import { appSettings, careGlobalVars } from '@/Shared/appSettings';

import libphonenumber from 'google-libphonenumber';

//const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

import cloneDeep from 'lodash/cloneDeep';
import _ from 'lodash';

const careHelpfulFunctions =
{
    generateUUID: function() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },

    // The date_value object is replaced with a reactive object owned in the startApplication.jsx unit.
    // This allows a single timer to update the value which all other uses can bind to.
    date_value: {
        value: null,
    },
    debug: function (msg) {
        utils.debug(msg);
    },

    browserTimezone: function () {
        const iana = Intl.DateTimeFormat().resolvedOptions().timeZone; // moment().tz.guess(); // guesses the users timezone, returns a moment timezone name;
        return timezoneMap.ianaToWindows(iana);
    },
    formatDateForLocale: function (dateTime, format, customerTimezone) {
        let fmt;
        
        switch (format) {
            case 'longDate': fmt = 'll'; break;
            case 'shortDate': fmt = 'l'; break;
            default: fmt = 'll LTS'; break;
        }

        return (dateTime ? moment(dateTime) : moment()).tz(careWindowsToMomentTimezoneMap[customerTimezone]).format((fmt).replace(/d/g, 'D').replace(/y/g, 'Y').replace(/a/g, 'A'));
    },
    formatHourOnlyDateTimeForLocale: function (dateTime, format, customerTimezone) {
        dateTime = dateTime + ":00:00";
        
        let fmt;
        
        switch (format) {
            case 'longDate': fmt = 'll'; break;
            case 'shortDate': fmt = 'l'; break;
            default: fmt = 'll LTS'; break;
        }

        return (dateTime ? moment(dateTime) : moment()).tz(careWindowsToMomentTimezoneMap[customerTimezone]).format((fmt).replace(/d/g, 'D').replace(/y/g, 'Y').replace(/a/g, 'A'));
    },
    getDateForLocale: function (dateTime, customerTimezone) {
        return locale.getTimezoneConvertedDate(dateTime, customerTimezone);
    },
    displayDateInLocale: function (dateTime, customerTimezone) {
        return locale.getDateInLocale(dateTime, customerTimezone);
    },
    regionCodeToName: function (regionCode) {
        var c = careRegionCodeList.find(function (element, index, array) {
            if (element.RegionCode == regionCode)
                return element;
        });

        if (c)
            return c.Name;
    },
    findMissingRegionCodes: function () {
        for (var prop in libphonenumber.metadata.countryToMetadata) {
            var name = careHelpfulFunctions.regionCodeToName(prop);
            if (!name)
                console.log(prop + ": " + name);
        }
    },
    formatPhoneNumber: function (phoneNumber, format) {
        if (!phoneNumber)
            return phoneNumber;

        // isPossibleNumber returns different results in different regions. For instance, a US region will return false for a 4 digit number
        // but a UK region will return true. Because short nubmers (<= 5 digits) are never real phone numbers - we skip 
        // calling E.164 formatting for those. Giving some consistincy accross regions for skipping short numbers.
        if (phoneNumber.length <= 6) 
            return phoneNumber;


        try {
            var phoneNumberFormat;
            var phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

            var customerRegionCode = token.CustomerRegionCode();
            if (!customerRegionCode)
                customerRegionCode = 'US';

            var forceCustomerPhoneNumberFormat = token.CustomerPhoneNumberFormat() || "National";

            var parsedPhoneNumber = phoneUtil.parse(phoneNumber, customerRegionCode);

            // if not a valid number return number unchanged
            if (!phoneUtil.isPossibleNumber(parsedPhoneNumber)) {
                return phoneNumber;
            }

            switch (format) {
                case 'E164':
                    phoneNumberFormat = libphonenumber.PhoneNumberFormat.E164;
                    break;
                case 'INTERNATIONAL':
                    phoneNumberFormat = libphonenumber.PhoneNumberFormat.INTERNATIONAL;
                    break;
                case 'RFC3966':
                    phoneNumberFormat = libphonenumber.PhoneNumberFormat.RFC3966;
                    break;
                case 'NATIONAL':
                    phoneNumberFormat = libphonenumber.PhoneNumberFormat.NATIONAL;
                    break;

                default: // If a specific format was not given, then pic NATIONAL if the phonenumber is in the customer's RegionCode or INTERNATIONAL if it is outside the customer's region
                    var countryCode = parsedPhoneNumber.getCountryCodeOrDefault();
                    var regionCodes = phoneUtil.getRegionCodesForCountryCode(countryCode);

                    if (regionCodes.find(
                        function (code) {
                            return code == customerRegionCode;
                        })
                    ) {
                        if (forceCustomerPhoneNumberFormat == "E.164")
                            phoneNumberFormat = libphonenumber.PhoneNumberFormat.E164;
                        else
                            phoneNumberFormat = libphonenumber.PhoneNumberFormat.NATIONAL;
                    }
                    else
                        phoneNumberFormat = libphonenumber.PhoneNumberFormat.INTERNATIONAL;
                    break;
            }

            return phoneUtil.format(parsedPhoneNumber, phoneNumberFormat);
        }
        catch (err) {
            return phoneNumber;
        }
    },

    isEqual: function (a, b) {
        return _.isEqual(a, b);
    },

    toRaw: function (value) {
        return toRaw(value);
    },

    isProxy: function (value) {
        return isProxy(value);
    },

    // return deep copy of source
    copy: function (source) {
        if (isProxy(source))
            source = toRaw(source);
        return cloneDeep(source);
    },

    // returns length of array or number of properties in object
    length: function (obj) {
        if (Array.isArray(obj)) {
            return obj.length;
        }
        else if (typeof obj === 'object') {
            return Object.keys(obj).length;
        }

        return 0;
    },

    propertyByIndex: function (obj, index) {
        if (Array.isArray(obj)) {
            return obj[index];
        }
        else if (typeof obj === 'object') {
            return obj[Object.keys(obj)[index]];
        }
        else
            return null;
    },

    firstProperty: function (obj) {
        if (Array.isArray(obj)) {
            return obj[0];
        }
        else if (typeof obj === 'object') {
            return obj[Object.keys(obj)[0]];
        }
        else
            return null;
    },

    lastProperty: function (obj) {
        if (Array.isArray(obj)) {
            return obj[obj.length - 1];
        }
        else if (typeof obj === 'object') {
            return obj[Object.keys(obj)[Object.keys(obj).length - 1]];
        }
        else
            return null;
    },

    durationSecondsAsString: function (totalSeconds) {
        const total = Math.floor(totalSeconds || 0);

        const hours = Math.floor(total / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;

        const pad = (num) => String(num).padStart(2, '0');

        if (hours > 0) {
            return `${hours}:${pad(minutes)}:${pad(seconds)}`;
        } else {
            return `${pad(minutes)}:${pad(seconds)}`;
        }
    },

    durationSecondsAsStringWithHours: function (seconds) {
        var seconds = Math.floor(seconds);

        var hours = Math.floor(seconds / (60 * 60));
        var seconds = seconds - (hours * 60 * 60);

        var minutes = Math.floor(seconds / 60);
        var seconds = seconds - (minutes * 60);

        var result = "";
        if (hours)
            result = ((hours <= 9) ? "0" : "") + hours + ":" + ((minutes <= 9) ? "0" : "") + minutes + ":" + ((seconds <= 9) ? "0" : "") + seconds;
        else if (minutes)
            result = ((minutes <= 9) ? "0" : "") + minutes + ":" + ((seconds <= 9) ? "0" : "") + seconds;
        else if (seconds)
            result = "00:" + ((seconds <= 9) ? "0" : "") + seconds;
        else
            result = "00:00";

        return result;
    },



    durationMinutesHoursSeconds: function (mins) {
        var hours = Math.floor(mins / 60);
        var minutes = Math.floor((mins - ((hours * 3600)) / 60));
        var seconds = Math.round((mins * 60) - (hours * 3600) - (minutes * 60));

        if (seconds == 60){
            minutes++;
            seconds = 0;
        }

        if (minutes >= 60) {
            hours++;
            minutes = minutes-60;
        }
        // Appends 0 when unit is less than 10
        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        return hours + ':' + minutes + ':' + seconds;

    },

    elapsedTimeAsString: function (startTime, endTime) {
        if (startTime > endTime) {
            //console.log("endTime: " + endTime + " should be larger than startTime: " + startTime);
            startTime = endTime;
        }

        var seconds = Math.floor((endTime - startTime) / 1000);

        return this.formatTotalTime(seconds);
    },

    elapsedTimeAsSeconds: function (startTime, endTime) {
        if (startTime > endTime) {
            //console.log("endTime: " + endTime + " should be larger than startTime: " + startTime);
            startTime = endTime;
        }

        return Math.floor((endTime - startTime) / 1000);
    },

    formatTotalTime(seconds) {
        var hours = Math.floor(seconds / (60 * 60));
        seconds = seconds - (hours * 60 * 60);

        var minutes = Math.floor(seconds / 60);
        seconds = Math.floor(seconds - (minutes * 60));

        var result = "";
        if (hours)
            result = hours + ":" + ((minutes <= 9) ? "0" : "") + minutes + ":" + ((seconds <= 9) ? "0" : "") + seconds;
        else if (minutes)
            result = ((minutes <= 9) ? "0" : "") + minutes + ":" + ((seconds <= 9) ? "0" : "") + seconds;
        else if (seconds)
            result = "00:" + ((seconds <= 9) ? "0" : "") + seconds;
        else
            result = "00:00";
        return result;
    },

    serverTimeToClientTime: function (theDate) {
        var adjustedDate = theDate + appSettings.ServerTimeOffset;
        return adjustedDate;
    },

    clientTimeToServerTime: function (theDate) {
        return theDate - appSettings.ServerTimeOffset;
    },

    get localeSettings() {
        return {
            NUMBER_FORMATS: {}
        };
        //appSettings.$locale;
    },

    format: function (filter, arg1, arg2, arg3) {
        return ''; //appSettings.$filter(filter)(arg1, arg2, arg3);
    },

    date: function () {
        return careHelpfulFunctions.date_value.value;
        //var date = new Date();
        //return date;
    },

    dateFromString: function (value) {
        var theDate = Date.parse(value);
        return theDate;
    },

    dateFromAbsoluteMilliseconds: function (ms) {
        return new Date(ms);
    },

    dateFromParts: function (year, month, day, hour, minute, second, ms) {
        return new Date(year, month, day, hour, minute, second, ms);
    },

    dateAddSeconds: function (originaldate, seconds) {
        return new Date(originaldate.getTime() + seconds * 1000);
    },

    dateAddMinutes: function (originaldate, minutes) {
        return new Date(originaldate.getTime() + minutes * 60 * 1000);
    },

    dateAddHours: function (originaldate, hours) {
        return new Date(originaldate.getTime() + hours * 60 * 60 * 1000);
    },

    dateAddDays: function (originaldate, days) {
        return new Date(originaldate.getTime() + days * 24 * 60 * 60 * 1000);
    },

    getISOWeekOfYear: function (dt, dowOffset) {
        dowOffset = typeof (dowOffset) == 'int' ? dowOffset : 0; //default dowOffset to zero
        var newYear = new Date(dt.getFullYear(), 0, 1);
        var day = newYear.getDay() - dowOffset; //the day of week the year begins on
        day = (day >= 0 ? day : day + 7);
        var daynum = Math.floor((dt.getTime() - newYear.getTime() -
            (dt.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) / 86400000) + 1;
        var weeknum;
        //if the year starts before the middle of a week
        if (day < 4) {
            weeknum = Math.floor((daynum + day - 1) / 7) + 1;
            if (weeknum > 52) {
                nYear = new Date(dt.getFullYear() + 1, 0, 1);
                nday = nYear.getDay() - dowOffset;
                nday = nday >= 0 ? nday : nday + 7;
                /*if the next year starts before the middle of
                      the week, it is week #1 of that year*/
                weeknum = nday < 4 ? 1 : 53;
            }
        }
        else {
            weeknum = Math.floor((daynum + day - 1) / 7);
        }
        return weeknum;
    },

    getDateOfISOWeek: function (w, y) {
        var simple = new Date(y, 0, 1 + (w - 1) * 7);
        var dow = simple.getDay();
        var ISOweekStart = simple;
        if (dow <= 4)
            ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
        else
            ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
        return ISOweekStart;
    },

    toInteger: function (value) {
        return parseInt(value);
    },

    toFloat: function (value) {
        return parseFloat(value);
    },

    toObject: function (s) {
        return JSON.parse(s);
    },

    toString: function (j, indent) {
        if (indent)
            return JSON.stringify(j, null, indent);
        else
            return JSON.stringify(j);
    },

    /*
       The following functions operate upon object arrays.
       These emulate some of the features found in C# LinQ
       and match methods on the server-side JsonObj class.
      
       When field is the argument, you can pass a string
       representing the field within each object using dot
       notation:
       [
          { "name": { "first": "fred", "last": "smith" } },
          { "name": { "first": "sam", "last": "jones" },
          ...
       ]
    
       A field of "name.first" would reference "fred" and "sam"
    */

    sum: function (array, field) {
        // Computes the sum of the values of the named field from each row in array

        var value = 0;
        for (var i = 0; i < array.length; i++) {
            var v1 = field ? careHelpfulFunctions.getField(array[i], field) : array[i];
            value += v1;
        }
        return value;
    },

    average: function (array, field) {
        // Computes the average of the values of the named field from each row in array

        var value = 0;
        for (var i = 0; i < array.length; i++) {
            var v1 = field ? careHelpfulFunctions.getField(array[i], field) : array[i];
            value += v1;
        }
        return value / array.length;
    },

    max: function (array, field) {
        // Computes the max value from the array of objects in the named field

        if (array.length < 1)
            return 0;

        var v0 = careHelpfulFunctions.getField(array[0], field);
        for (var i = 1; i < array.length; i++) {
            var v1 = field ? careHelpfulFunctions.getField(array[i], field) : array[i];
            if (v1 > v0)
                v0 = v1;
        }
        return v0;
    },

    min: function (array, field) {
        // Computes the min value from the array of objects in the named field

        if (array.length < 1)
            return 0;

        var v0 = careHelpfulFunctions.getField(array[0], field);
        for (var i = 1; i < array.length; i++) {
            var v1 = field ? careHelpfulFunctions.getField(array[i], field) : array[i];
            if (v1 < v0)
                v0 = v1;
        }
        return v0;
    },

    take: function (array, limit) {
        // Takes the first "limit" elements from array

        var tmp = [];
        for (var i = 0; i < array.length && i < limit; i++)
            tmp.push(array[i]);
        return tmp;
    },

    skip: function (array, count) {
        // Skips the "count" elements are returns the remaining

        var tmp = [];
        for (var i = count; i < array.length; i++)
            tmp.push(array[i]);
        return tmp;
    },

    reverse: function (array) {
        // For convenience, reverses the order of the array elements

        return array.reverse();
    },

    sort: function (array, field) {
        // Sorts the objects in array based upon the named field within each object

        var tmp = [];
        for (var i = 0; i < array.length; i++)
            tmp.push(array[i]);

        tmp.sort(function (a, b) {
            var valuea = careHelpfulFunctions.getField(a, field);
            var valueb = careHelpfulFunctions.getField(b, field);

            if (typeof valuea === 'string') {
                if (valuea < valueb)
                    return -1;
                else if (valuea > valueb)
                    return 1;
                else
                    return 0;
            }
            else if (typeof valuea === 'number') {
                return valuea - valueb;
            }
            else if (typeof valuea === 'boolean') {
                if (valuea && !valueb)
                    return 1;
                else if (valueb && !valuea)
                    return -1;
                else
                    return 0;
            }
            else
                return 0;
        });
        return tmp;
    },

    arrayToObject: function (array, keyFunc, valueFunc) {
        var tmp = {};
        for (let v of array)
            tmp[keyFunc(v)] = valueFunc ? valueFunc(v) : v;
        return tmp;
    },

    toLookup: function (array, keyfield, valuefield, allowmultiples, asarray, delimiter) {
        // Converts the array to a lookup list (object) with the named keyfield as the key and the named valuefield as the value

        // Example array: [{'name':'joe','city':'provo'},{'name':'sam':'city':'lehi'}]
        // toLookup(array, 'name', 'city'):
        // {'joe':'provo','sam':'lehi'}

        delimiter = delimiter || ',';

        var tmp = {};
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var value;
            if (valuefield)
                value = careHelpfulFunctions.getField(item, valuefield);
            else
                value = item;

            var field = careHelpfulFunctions.getField(item, keyfield);
            if (!field)
                continue;

            if (field in tmp && allowmultiples && asarray && Array.isArray(tmp[field]))
                tmp[field].push(value);
            else if (field in tmp && allowmultiples && asarray && !Array.isArray(tmp[field]))
                tmp[field] = [tmp[field], value];
            else if (field in tmp && allowmultiples && (typeof tmp[field] === 'object') && (typeof value === 'object'))
                tmp[field] = tmp[field][valuefield] + delimiter + value[valuefield];
            else if (field in tmp && allowmultiples && (typeof value === 'object'))
                tmp[field] = tmp[field] + delimiter + value[valuefield];    
            else if (field in tmp && allowmultiples)
                tmp[field] = tmp[field] + delimiter + value;
            else
                tmp[field] = value;
        }
        return tmp;
    },

    toArray: function (object) {
        // Converts the object into an array as:
        // [
        //   {
        //      "key": "<key>",
        //      "value": { ... }
        //   }
        // ]

        const arr = [];

        for (let key in object)
            if (object.hasOwnProperty(key))
                arr.push({ key: key, value: object[key] });

        return arr;
    },

    select: function (array, field) {
        // Returns a new array made up of just the value from the named field from each row

        var tmp = [];
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            tmp.push(careHelpfulFunctions.getField(item, field));
        }
        return tmp;
    },

    selectMulti: function (array, fieldlist, namelist) {
        // Returns a new array made up of just the list of fields (fieldslist is an array)  from each row

        var tmp = [];
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var row = {};
            for (var j = 0; j < fieldlist.length; j++) {
                var fields = fieldlist[j].split('.');
                if (namelist)
                    row[namelist[j]] = careHelpfulFunctions.getField(item, fieldlist[j]);
                else
                    row[fields[fields.length - 1]] = careHelpfulFunctions.getField(item, fieldlist[j]);
            }
            tmp.push(row);
        }
        return tmp;
    },

    groupBy: function (array, field) {
        var group = {};
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var key = careHelpfulFunctions.getField(item, field);
            if (!group[key])
                group[key] = [];

            group[key].push(item);
        }
        var result = [];
        for (var key in group) {
            if (group.hasOwnProperty(key)) {
                var value = group[key];
                var record = {
                    key: key,
                    values: value
                };
                result.push(record);
            }
        }
        return result;
    },

    groupByMulti: function (array, fieldlist) {
        var group = {};
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var keys = [];
            for (var j = 0; j < fieldlist.length; j++) {
                var k = careHelpfulFunctions.getField(item, fieldlist[j]);
                keys.push(k);
            }
            var keystr = JSON.stringify(keys);
            if (!group[keystr])
                group[keystr] = [];

            group[keystr].push(item);
        }
        var result = [];
        for (var key in group) {
            if (group.hasOwnProperty(key)) {
                var keyobj = JSON.parse(key);
                var value = group[key];
                var record = {
                    key: keyobj,
                    values: value
                };
                result.push(record);
            }
        }
        return result;
    },

    filterEqual: function (array, field, value) {
        // Returns a new array containing only the rows where the named field matches value

        var tmp = [];
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var f = careHelpfulFunctions.getField(item, field);
            if (f == value)
                tmp.push(item);
        }
        return tmp;
    },

    filterNotEqual: function (array, field, value) {
        // Returns a new array containing only the rows where the named field does not match value

        var tmp = [];
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var f = careHelpfulFunctions.getField(item, field);
            if (f != value)
                tmp.push(item);
        }
        return tmp;
    },

    getField: function (obj, name) {
        // Gets a field from the object using dot notation to walk the object hierarchy

        var members = name.split('.');
        var i = 0;
        while (i < members.length) {
            var member = members[i++];
            if (i == members.length && member.includes('(') && member.includes(')')) {
                var func = member.substr(0, member.indexOf('('));
                var args = member.substr(member.indexOf('('));
                args = args.substr(1, args.length - 2);
                if (args.length == 0) args = null;
                switch (func) {
                    case 'count': obj = obj.length; break;
                    case 'average': obj = careHelpfulFunctions.average(obj, args); break;
                    case 'max': obj = careHelpfulFunctions.max(obj, args); break;
                    case 'min': obj = careHelpfulFunctions.min(obj, args); break;
                    case 'sum': obj = careHelpfulFunctions.sum(obj, args); break;
                    case 'asdate': obj = Date.parse(obj); break;
                    default:
                        obj = null;
                        break;
                }
            }
            else if (member.includes('[') && member.includes(']')) {
                var memb = member.substr(0, member.indexOf('['));
                var indx = member.substr(member.indexOf('['));
                obj = obj[memb][parseInt(indx.substr(1, indx.length - 2))];
            }
            else
                obj = obj[member];
        }

        return obj;
    },

    /**********************************************************/

    clear: function (objToClear) {
        // modify the existing object so existing references remain intact
        if (Array.isArray(objToClear)) {
            objToClear.splice(0);
        }
        else if (typeof objToClear === 'object') {
            for (var prop in objToClear) {
                if (objToClear.hasOwnProperty(prop))
                    delete objToClear[prop];
            }
        }
    },

    urlEncode: function (text) {
        return window.encodeURIComponent(text);
    },

    urlDecode: function (text) {
        return window.decodeURIComponent(text);
    },

    hasAccess: function (accessId) {
        return utils.document_cache.hasAccess('hasAccess', { Enabled: true, ID: accessId } );
    },

    hasRole: function (role) { // TODO: Finish
        //return true;

        const roles = token.CustomerRoles(); // appSettings.careTokenService.CustomerRoles();

        if (roles) {
            const found = roles.includes(role);

            //utils.debug(` ** ** ** ** hasRole('${role}'):${found ? 'yes' : 'no'} ** ** ** ** `);

            return found;
        }

        //utils.debug(` ** ** ** ** hasRole('${role}') roles is unassigned!! ** ** ** ** `);

        return false;
    },

    hasModule: function (moduleName, version) {
        if (utils.global_variables.InstalledModules) {
            var found = utils.global_variables.InstalledModules.find(item => {
                return (item.Name === moduleName && (version === undefined || item.Version === version));
            });

            //utils.debug(` ** ** ** ** hasModule('${moduleName}'):${found ? 'yes' : 'no'} ** ** ** ** `);

            return !!found;
        }

        //utils.debug(` ** ** ** ** hasModule('${moduleName}'): InstalledModules is not assigned ** ** ** ** `);

        return false;
    },

    //moduleName and moduleVersion are both optional.
    getModuleConfig: function (moduleName, moduleVersion) {
        if (careGlobalVars.ModuleConfig) {
            return careGlobalVars.ModuleConfig.filter(config => (!moduleName || config.ModuleName == moduleName) && (!moduleVersion || config.ModuleVersion == moduleVersion));
        }
        return [];
    },

    //moduleName and moduleVersion are both optional.
    getModuleConfigByName: function (configName, moduleName, moduleVersion) {
        if (careGlobalVars.ModuleConfig) {
            var specificModules = careGlobalVars.ModuleConfig.filter(config => (!moduleName || config.ModuleName == moduleName) && (!moduleVersion || config.ModuleVersion == moduleVersion));
            var configs = [];
            for (var i = 0; i < specificModules.length; i++) {
                for (var key in specificModules[i]) {
                    if (key == configName) {
                        var config = {
                            ModuleName: specificModules[i].ModuleName,
                            ModuleVersion: specificModules[i].ModuleVersion
                        };
                        config[key] = specificModules[i][key];
                        configs.push(config);
                    }
                }
            }
            return configs;
        }
        return [];
    },

    /*** Functions to help determine mobile devices or small screen resolutions ***/
    hasMobileOrientation: function () {
        // mobile devices have window orientation and desktops do not.  tablets, chrome ultrabooks, other desktop androids behave like mobile, so may need to consider that
        return (typeof window.orientation !== "undefined");
    },

    isMobileDevice: function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },

    hasSmallScreenResolution: function (x, y) {
        // allow user to pass in their own definition of small screen size, but if they dont pass in anything we will set to 800 for width, and 600 for height
        if (x === undefined || x === 'undefined')
            x = 800;

        if (y === undefined || y === 'undefined')
            y = 600;

        if (window.innerWidth <= x && window.innerHeight <= y) {
            return true;
        } else {
            return false;
        }
    },

    isFullScreenViewMode: function () {
        return document.webkitIsFullScreen;
    },

    get hostname() {
        return window.location.hostname;
    },

    get window() {
        return window;
    },

    get guidedAssistantHSMs() {
        return careHSMs?.filter(c => c.controlData.IsGuidedAssistant);
    },

    globalMessageBroadcast: function (message, data) {
       utils.globalMessageBroadcast(message, data);
    },
    encodeBase64: function (data) {
        return btoa(data);
    },
    decodeBase64: function (data) {
        return atob(data);
    },

    renameProperty: function (object, oldname, newname) {
        // Renames a property of an object while preserving the order of the properties
        const arr = careHelpfulFunctions.toArray(object);
        const idx = arr.findIndex(e => e.key == oldname);
        if (idx >= 0) {
            arr[idx].key = newname;
            return careHelpfulFunctions.toLookup(arr, "key", "value");
        }
        return object;
    },

    reorderProperty: function (object, name, direction) {
        // Changes the order of a property within an object
        // direction: 1 = down, -1 = up
        const arr = careHelpfulFunctions.toArray(object);
        const idx = arr.findIndex(e => e.key == name);
        switch (direction) {
            case 1: // down
                if (idx < arr.length - 1)
                    arr.splice(idx + 1, 0, arr.splice(idx, 1)[0]);
                break;
            case -1: // up
                if (idx > 0)
                    arr.splice(idx - 1, 0, arr.splice(idx, 1)[0]);
                break;
            default:
                return object;
        }
        return careHelpfulFunctions.toLookup(arr, "key", "value");
    },

    getEvents: function (props) {
        // This is specifically to filter out items from a schema to extract only those that are defined as UIActions, and then just return an array of the event names.
        const events = [];
        for (let key in props) {
            const p = props[key];
            if (p.type == 'array' && p.items && p.items.$ref == '/Apps/Schema/AnyOf/schema/public/Platform.Schema.BaseTypes.v1/UIAction')
                events.push({ name: key });
        }
        return events;
    },

    stripHTML(html) {
        // eslint-disable-next-line no-useless-escape
        html = html.replace(/<br\s*[\/]?>/gi, "\n");
        let doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent.trim().replace(/\u200B/g, '');
    },
    debounce(func, timeout = 300){
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    },

    waitUntilIdle: function (f) {
        nextTick(f);
    },

    set: function (obj, field, value) {
        obj[field] = value;
    },
    delete: function (obj, field) {
        delete obj[field];
    },
};

export default careHelpfulFunctions;